module.exports = __webpack_public_path__ + "assets/img/df92c8555ed7fd11f796648b813ae7a6.png";